import { ISignInMagicLinkXP } from '@faire/web-api--source/indigofair/seo/ISignInMagicLinkXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * This is part of the sign-in improvement - Magic link Prominence test
 * PRD: https://www.notion.so/faire/Sign-in-flow-b9efea9e78224d9f8c42dccbdb2c95d7
 */
export const ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024 =
  'ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024' as SettingConst<
    'ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024',
    keyof typeof ISignInMagicLinkXP.Bucket,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
